module.exports = __webpack_public_path__ + "static/media/ic_profile.5eb22349.png";